<template>
  <van-dialog v-model="show_" title="您已成功签到 3 天！" show-confirm-button confirm-button-color="#117281"
    theme="round-button" @confirm="confirm">
    <div class="info">
      <p>奖励如下：</p>
      <p>{{ displayString }}</p>
      <p class="price">(总价值1340易加积分)</p>
    </div>
  </van-dialog>

</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    displayString: {
      type: String,
      default: ''
    },
    linkCoupon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show_: false
    }
  },
  watch: {
    show (val) {
      this.show_ = val || false
    }
  },
  computed: {

  },
  methods: {
    confirm () {
      this.show_ = false
      this.$emit('update:show', this.show_)
      if (this.linkCoupon) {
        this.$router.push({ name: 'userCoupon' })
      }
    }
  }
}
</script>
<style lang='less' scoped>
.info {
  text-align: center;
  line-height: 1.5;
  padding: 10px;
  .price{
    font-size: 12px;
    font-weight: 300;
  }
}
</style>
